import { render } from "./YearFilter.vue?vue&type=template&id=15fa466e&scoped=true"
import script from "./YearFilter.vue?vue&type=script&lang=js"
export * from "./YearFilter.vue?vue&type=script&lang=js"

import "./YearFilter.vue?vue&type=style&index=0&id=15fa466e&scoped=true&lang=less"

import exportComponent from "/home/runner/work/DMA-Frontend/DMA-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15fa466e"]])

export default __exports__